import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './NewRequestLink.css';
import Aux from '../../../hoc/Auxiliary/Auxiliary';
import Backdrop from '../Backdrop/Backdrop';
import webImg from '../../../assets/images/web-icon.png';
import closeImg from '../../../assets/images/close-icon.png';
import linkImg from '../../../assets/images/link-white-icon.png';
import telegramImg from '../../../assets/images/telegram-icon.png';
import Icon from '../Icon/Icon';
import ButtonIcon from '../ButtonIcon/ButtonIcon';
import Input from '../Input/Input';
import logError from '../../../store/LogError';
import axios from '../../../axios-trips';
import * as actionTypes from '../../../store/actions';

class NewRequestLink extends Component {

  createInputConfig = (elementType,
                       elementConfig,
                       label,
                       value='',
                       validation={},
                       valid=true,
                       extraClass=null,
                       extraAction=null) => {
    return ({
      elementType: elementType,
      elementConfig: elementConfig,
      label: label,
      value: value,
      validation: validation,
      valid: valid,
      extraClass: extraClass,
      extraAction: extraAction,
      touched: false,
      errorMessage: null,
      loading: false
    });
  }

  state = {
    loading: false,
    requestForm: {
      managers: this.createInputConfig(
        'select',
        {
          options: []
        },
        'Менеджер: ',
        '',
        { required: true },
        false),
      link: this.createInputConfig(
        'display-copy',
        { type: 'textarea', rows: 4 },
        'Ссылка: ',
        '',
        { },
        true)
    },
    formIsValid: false
  }

  escFunction = (event) => {
    if(event.keyCode === 27) {
      this.closeCard();
    }
  }

  updateLoading = (attr, loading) => {
    const updatedCarriers = {...this.state.requestForm};
    updatedCarriers[attr].loading = loading;
    this.setState({ cardForm: updatedCarriers });
  }

  componentDidMount(){
    document.addEventListener("keydown", this.escFunction, false);
  }

  createManagers() {
    if (this.props.managers.length > 2 || this.state.requestForm.managers.loading) {
      return;
    }
    this.updateLoading("managers", true);
    axios({
      method: 'get',
      url: '/api/v1/managers',
      headers: {'Authorization': 'Bearer ' + this.props.access_token},
    })
    .then(response => {
      this.updateLoading("managers", false);
      const cardForm = {...this.state.requestForm};
      this.props.onSetManagers(response.data);
    })
    .catch(error => {
      this.updateLoading("managers", false);
      console.log(error.response);
      if (error.response) {
        logError(
          this.props.access_token,
          this.props.codeToMessage[error.response.status],
          '/api/v1/managers'
        );
        this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
      } else if (!error.response) {
        this.props.addNotification("Ошибка на сервере.", "Danger");
      }
    });
  }

  componentWillUnmount(){
    document.removeEventListener("keydown", this.escFunction, false);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.managers !== this.props.managers) {
      const updatedRequestForm = {...this.state.requestForm};
      updatedRequestForm.managers.elementConfig.options = this.getManagers();
      if (this.props.managers.length > 0) {
        updatedRequestForm.managers.value = updatedRequestForm.managers.elementConfig.options[0].value;
        this.setState({ formIsValid: true });
      }
      this.setState({ requestForm: updatedRequestForm });
    }

    if (!prevProps.showNewRequestLink && this.props.showNewRequestLink && this.props.managers.length <= 2) {
      this.createManagers();
    }
  }

  getManagers() {
    let managers = [];
    this.props.managers.forEach(manager => {
      if (manager.username) {
        managers.push({value: manager.name, displayValue: manager.name});
      }
    });
    return managers;
  }

  checkValidity(value, rules) {
    let isValid = true;

    if (rules.required) {
        isValid = (value ? (value.trim !== '') : false) && isValid;
    }

    if (rules.type === 'email') {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      isValid = re.test(value) && isValid;
    }

    if (rules.type === "confirmPassword") {
      isValid = this.state.registerForm.password.value === value && isValid;
    }

    if (rules.minLength) {
      isValid = value.length >= rules.minLength && isValid;
    }

    if (rules.maxLength) {
      isValid = value.length <= rules.maxLength && isValid;
    }

    return isValid;
  }

  getErrorMessage(value, rules) {
    let errorMessage = '';

    if (rules.required && (value ? (value.trim === '') : true)) {
      errorMessage = 'Это поле обязательное';
    }

    if (rules.type == 'email') {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(value)) {
        errorMessage = 'Введите почту';
      }
    }

    if (rules.type === "confirmPassword" && this.state.registerForm.password.value !== value) {
      errorMessage = 'Пароли должны совпадать';
    }

    if (rules.minLength && value.length < rules.minLength) {
      errorMessage = 'Минимальная длина: ' + rules.minLength;
    }

    if (rules.maxLength && value.length > rules.maxLength) {
      errorMessage = 'Максимальная длина: ' + rules.minLength;
    }

    return errorMessage;
  }

  inputChangedHandler = (event, elementId) => {
    const updatedOrderForm = {
      ...this.state.requestForm
    }
    const updatedFormElement = {
      ...updatedOrderForm[elementId]
    }

    if ((event.target.value === '' || event.target.value === null) &&
          updatedOrderForm[elementId].elementConfig.type === 'number') {
      event.target.value = 0;
    }
    updatedFormElement.value = event.target.value;
    updatedFormElement.touched = true;
    updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
                                                  updatedFormElement.validation);
    updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
                                                           updatedFormElement.validation);
    updatedOrderForm[elementId] = updatedFormElement;
    let capacityFilled = null;

    let formIsValid = true;
    for (let inputIdentifier in updatedOrderForm) {
      formIsValid = updatedOrderForm[inputIdentifier].valid && formIsValid;
    }

    this.setState({ requestForm : updatedOrderForm, formIsValid: formIsValid });
  }

  newRequestHandler = (event) => {
    event.preventDefault();
    const data = {
      name: this.state.requestForm.managers.value
    }

    axios({
      method: 'post',
      url: '/api/v1/managers/authorize',
      data: data,
      headers: {'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.access_token},
    })
    .then(response => {
      console.log(response);
      this.props.addNotification("Ссылка успешно создана.", "Success");
      const updatedRequestForm = {...this.state.requestForm};
      updatedRequestForm.link.value = "Пожалуйста, создайте заявку онлайн (ссылка действительна в течение 15 минут):\n" + window.location.origin + "/new-request?token=" + response.data;
      this.setState({ requestForm: updatedRequestForm });

      document.getElementById("manager-link").select();
      document.execCommand("copy");
      this.props.addNotification("Сообщение скопировано в буфер.", "Success");
    })
    .catch(error => {
      console.log(error);
      this.setState({ loading: false });
      if (error.response) {
        logError(
          this.props.access_token,
          this.props.codeToMessage[error.response.status],
          '/api/v1/managers/authorize'
        );
        this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
      }
    });
  }

  telegramMsg = (event) => {
    event.preventDefault();
    const data = {
      name: this.state.requestForm.managers.value
    }

    for (let i = 0; i < this.props.managers.length; i++) {
      if (this.props.managers[i].name === data.name) {
        if (this.props.managers[i].tbotId) {
          this.sendTelegramMessage(data, this.props.managers[i].tbotId);
        } else {
          this.props.addNotification("У Менеджера " + data.name + " нет телеграма.", "Neutral");
        }
        break;
      }
    }
  }

  sendTelegramMessage(data, chatId) {
    axios({
      method: 'post',
      url: '/api/v1/managers/send?chatId=' + chatId,
      data: data,
      headers: {'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.access_token},
    })
    .then(response => {
      console.log(response);
      this.props.addNotification("Сообщение было успешно отправлено.", "Success");
    })
    .catch(error => {
      console.log(error);
      if (error.response) {
        logError(
          this.props.access_token,
          this.props.codeToMessage[error.response.status],
          '/api/v1/managers/send?chatId=' + chatId
        );
        this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
      }
    });
  }

  closeCard = () => {
    this.props.onShowNewRequestLink(false);
  }

  render () {
    const requestFormArray = [];
    for (let key in this.state.requestForm) {
      requestFormArray.push({ id: key, config: this.state.requestForm[key] });
    }

    let card = (
      <Aux>
        <div className={classes.Header}>
          <Icon iconClass={classes.CarIcon} iconSource={webImg} iconAlt='' className={classes.CardIcon} />
          <p>Новая Ссылка Создания Рейса</p>

          <button className={classes.CloseButton} onClick={this.closeCard}>
            <Icon iconClass={classes.CloseIcon} iconSource={closeImg} iconAlt='' />
          </button>
          <p style={{height: "100%"}}></p>
        </div>

        <form className={classes.NewRequestForm}>
          <div className={classes.Body} >
            {requestFormArray.map(formElement => {
              return (
                <Input
                  key={formElement.id}
                  label={formElement.config.label}
                  elementType={formElement.config.elementType}
                  elementConfig={formElement.config.elementConfig}
                  value={formElement.config.value}
                  extraClass={formElement.config.extraClass}
                  extraAction={formElement.config.extraAction}
                  loading={formElement.config.loading}
                  changed={(event) => this.inputChangedHandler(event, formElement.id)} />
                );
            })}
          </div>

          <div className={classes.Footer}>
            <ButtonIcon
              btnType='Neutral'
              clicked={this.newRequestHandler}
              iconClass={classes.ButtonIcon}
              iconSource={linkImg}
              disabled={!this.state.formIsValid}
              iconAlt=''>СОЗДАТЬ ССЫЛКУ</ButtonIcon>
            <ButtonIcon
              btnType='Success'
              clicked={this.telegramMsg}
              iconClass={classes.ButtonIcon}
              iconSource={telegramImg}
              disabled={!this.state.formIsValid}
              iconAlt=''>ОТПРАВИТЬ В ТЕЛЕГРАМЕ</ButtonIcon>
          </div>
        </form>
      </Aux>
    );

    return(
      <Aux>
        <Backdrop show={this.props.showNewRequestLink} clicked={this.closeCard} />
        <div
          className={classes.CardModal}
          style={{transform: this.props.showNewRequestLink ? 'translateY(0)' : 'translateY(-100vh)',
                  opacity: this.props.showNewRequestLink ? '1' : '0'}}>
          {card}
        </div>
      </Aux>
    );
  }
};

const mapStateToProps = state => {
  return {
    access_token: state.access_token,
    managers: state.managers,
    showNewRequestLink: state.showNewRequestLink,
    codeToMessage: state.codeToMessage
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addNotification: (notification, notificationType) => dispatch({ type: actionTypes.ADD_NOTIFICATION,
                                                                   notification: notification,
                                                                   notificationType: notificationType }),
    onShowNewRequestLink: (showNewRequestLinked) => dispatch({ type: actionTypes.SHOW_NEW_REQUEST_LINK, showNewRequestLinked: showNewRequestLinked }),
    onSetManagers: (managers) => dispatch({ type: actionTypes.SET_MANAGERS,
                                            managers: managers}),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewRequestLink);



// WEBPACK FOOTER //
// ./src/components/UI/NewRequestLink/NewRequestLink.js